import { render, staticRenderFns } from "./PatientSearchTable.vue?vue&type=template&id=3b973c3c&scoped=true&"
import script from "./PatientSearchTable.vue?vue&type=script&lang=js&"
export * from "./PatientSearchTable.vue?vue&type=script&lang=js&"
import style0 from "./PatientSearchTable.vue?vue&type=style&index=0&id=3b973c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b973c3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
